export default {
  props: {
    question: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    issue() {
      return this.question.issue
    }
  },
  methods: {
    onUpdate() {
      this.$emit('update', this.question)
    }
  }
}
